<template>
    <v-container style="padding: 16px;">
        <v-row
            v-if="!$vuetify.breakpoint.xs"
            class="m-0"
        >
            <v-col>
                <v-data-table
                    id="main_history_table"
                    ref="main_history_table"
                    fixed-header
                    :headers="headers"
                    :items="getTicketHistory"
                    item-key="key"
                    hide-default-footer
                    :items-per-page="-1"                          
                />
            </v-col>
        </v-row>

        <div
            v-if="$vuetify.breakpoint.xs"
            id="ticket-history-cards"
        >
            <v-card
                v-for="item in getTicketHistory"
                :key="item.rowid"
                flat
                tile
            >
                <table class="px-3 py-4">
                    <tr>
                        <td>Posted Date:</td>
                        <td>{{ item.posted }}</td>
                    </tr>
                    <tr>
                        <td>Account:</td>
                        <td>{{ item.posted_by }}</td>
                    </tr>
                    <tr>
                        <td>Description:</td>
                        <td>{{ item.description }}</td>
                    </tr>
                </table>
            </v-card>
        </div>
    </v-container>
</template>

<script>
import moment from 'moment';

export default {
    name: 'History',
    data: () => ({
        headers: [
            {
                text: 'Posted Date',
                value: 'posted',
                align: 'left',
                width: '200px',
                sortable: false,
            },
            {
                text: 'Account',
                value: 'posted_by',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Description',
                value: 'description',
                align: 'left',
                sortable: false,
            },
        ],
    }),
    computed: {
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        },
        getTicketHistory() {
            if(this.getTicketDetails && this.getTicketDetails?.Ticket_History) {
                return this.getTicketDetails.Ticket_History.map((item) => {
                    item.posted = moment(item.posted).format(' DD MMM YYYY, hh:mm A');
                    return item;
                });
            } else {
                return [];
            }
        }
    },
};
</script>

<style>
    #main_history_table.v-data-table {
        border: 1px solid var(--ll-border);
        width: 100%;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        overflow: hidden;
    }
    #main_history_table.v-data-table__wrapper {
        border-radius: 4px;
    }
    #main_history_table .v-data-table-header th{
        background: var(--ll-surface-subtle) !important;
    }

    #ticket-history-cards .v-card {
        border-bottom: 1px solid #d3d5d8;
    }
    #ticket-history-cards .ticket-card-info {
        border-radius: 4px;
        border: 1px solid var(--ll-border-subtle);
        height: 28px;
        display: inline-block;
        min-width: 40px;
        margin-top: 16px;
        margin-bottom: 16px;
        margin-right: 8px;
        padding: 4px 8px;
        color: var(--ll-text-primary);
        font-size: 12px;
    }
    #ticket-history-cards table {
        font-size: 12px;
        width: 100%;
    }
    #ticket-history-cards table tr td:first-child {
        width: 82px;
    }
    #ticket-history-cards table tr td:nth-child(2) {
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 0;
    }
    #ticket-history-cards .status-open-chip {
        margin-right: 10px;
    }
</style>
